import { Layout, Page, SectionHeader } from "@apex/component-library";
import { Box } from "@chakra-ui/react";
import { AxiosError } from "axios";
import { useState } from "react";

import { useGetAccountDetails } from "../api/useGetAccountDetails";
import useGetCallsAndAlertsOpenDetails from "../api/useGetCallsAndAlertsOpenDetails";
import AccountDetails from "../components/AccountDetails";
import AccountLookupWrapper from "../components/AccountLookup/";
import CreateCallFormWrapper from "../components/CreateCallForm/CreateCallFormWrapper";
import OpenCallsAndAlertsDetails from "../components/OpenCallsAndAlertsDetails";
import { withPermissions } from "../hoc/withPermissions";
import { Permissions } from "../permissions";

const CreateCallPage = () => {
  const [accountId, setAccountId] = useState("");
  const { data: accountData, status: accountDataStatus } =
    useGetAccountDetails(accountId);

  const {
    data: callsAndAlertsData,
    status: callsAndAlertsStatus,
    error: callsAndAlertsError,
  } = useGetCallsAndAlertsOpenDetails();

  return (
    <Page title="Create Margin Call">
      <Layout type="fiftyFifty">
        <Box>
          <SectionHeader>Margin Call Details</SectionHeader>
          <AccountLookupWrapper
            setAccountId={setAccountId}
            accountId={accountId}
          />
          <AccountDetails accountId={accountId} accountData={accountData} />
          <CreateCallFormWrapper
            accountId={accountId}
            accountData={accountData}
            setAccountId={setAccountId}
          />
        </Box>
        <Box>
          <OpenCallsAndAlertsDetails
            hasAccountData={!!accountData}
            entries={callsAndAlertsData?.records}
            apiStatus={callsAndAlertsStatus}
            accountDataStatus={accountDataStatus}
            accountId={accountId}
            error={callsAndAlertsError as AxiosError}
          />
        </Box>
      </Layout>
    </Page>
  );
};

export default withPermissions(CreateCallPage, [
  Permissions.MarginReportsModify,
  Permissions.AccountRead,
  Permissions.MarginProcessingUiNavView,
]);
